module.exports = __webpack_public_path__ + "static/media/DOM.457f46fe.svg";